import Auth from "@/Auth.js";

export default (to, from, next) => {
  Auth.setItem("last_route", from.path);
  console.log("window.location.hostname ", window.location.hostname);
  console.log("to.path ", to.path);

  if (
    to.path != "/selo/diagnostico" &&
    !to.path.includes("/diagnostic/selo/download") &&
    !to.path.includes("/auth") &&
    !to.path.includes("/usuario")
  ) {
    next({
      path: "/selo/diagnostico",
    });
  } else {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      if (!Auth.isLogged()) {
        next({
          path: "/auth/login",
        });
      } else {
        console.log("4");
        next();
      }
    }

    if (to.matched.some((record) => record.meta.requiresNoAuth)) {
      if (Auth.isLogged()) {
        next({
          path: "/selo/diagnostico",
        });
      } else {
        next();
      }
    }
    if (to.matched.some((record) => record.meta.verifyVisibleRelatorio)) {
      const user = JSON.parse(localStorage.getItem("user"));
      const relatorioAdm = JSON.parse(user.grupo.relatorioAdm) || [];
      if (
        relatorioAdm.filter((item) => item == to.params.relatorioRoute)
          .length === 0 &&
        user.email !== "admin@admin.com.br"
      ) {
        next({
          path: "/selo/diagnostico",
        });
      } else {
        next();
      }
    } else {
      next();
    }
  }
};
